<template>
  <path
    d="M20 2.00024H4C2.9 2.00024 2.01 2.90024 2.01 4.00024L2 22.0002L6 18.0002H20C21.1 18.0002 22 17.1002 22 16.0002V4.00024C22 2.90024 21.1 2.00024 20 2.00024ZM9 11.0002H7V9.00024H9V11.0002ZM13 11.0002H11V9.00024H13V11.0002ZM17 11.0002H15V9.00024H17V11.0002Z"
  />
</template>
